/* Independent viewport behavior for hero sliders. No catalog/consent state changes. */
(function () {
  if (window.LBResponsiveBehavior) return;
  var mq = matchMedia('(max-width: 768px)');
  function device() { return mq.matches ? 'Mobile' : 'Desktop'; }
  function apply(el) {
    var d = device(), data = el.dataset;
    var style = data['lbStyle' + d] || 'bars';
    el.dataset.autoplay = data['lbAutoplay' + d] === 'true' ? 'true' : 'false';
    el.dataset.speed = String(Number(data['lbSpeed' + d]) || 7000);
    el.style.setProperty('--lb-slideshow-speed', el.dataset.speed + 'ms');
    ['arrows', 'dots', 'bars'].forEach(function (key) { el.removeAttribute('data-' + key); });
    if (style === 'arrows') el.setAttribute('data-arrows', 'true');
    if (style === 'bars' || style === 'dots') el.setAttribute('data-dots', 'true');
    if (style === 'bars') el.setAttribute('data-bars', 'true');
    el.querySelectorAll('parallax-image').forEach(function (parallax) {
      var image = parallax.querySelector('[data-parallax-image]');
      if (!image) return;
      image.dataset.angle = image.dataset['lbAngle' + d] || image.dataset.lbAngleDesktop || 'top';
      // Each provider component keeps its own geometry; disable its animation loop when off.
      if (!parallax.lbResponsiveGuard && typeof parallax.init === 'function') {
        var originalInit = parallax.init, originalScroll = parallax.scrollHandler;
        function enabled() { return el.dataset['lbParallax' + device()] === 'true'; }
        parallax.init = function () { if (!enabled()) { this.isActive = false; return; } return originalInit.apply(this, arguments); };
        parallax.scrollHandler = function () { if (!enabled()) { this.isActive = false; return; } return originalScroll.apply(this, arguments); };
        parallax.lbResponsiveGuard = true;
      }
      clearTimeout(parallax.timeout); parallax.isActive = false;
      ['width','height','left','right','top','bottom','transform'].forEach(function (property) { image.style.removeProperty(property); });
      parallax.windowInnerHeight = window.innerHeight;
      if (parallax.parallaxImage && typeof parallax.init === 'function') parallax.init();
    });
    var wrapper = el.closest('.slideshow-wrapper');
    var pause = wrapper && wrapper.querySelector('.slideshow__pause');
    if (pause) pause.hidden = el.dataset.autoplay !== 'true' || style !== 'bars';
  }
  function hook() {
    var T = window.theme;
    if (!T || !T.SlideshowSection || T.SlideshowSection.prototype.lbResponsiveHook) return;
    var proto = T.SlideshowSection.prototype, init = proto.init;
    proto.init = function () {
      if (this.slideshow && this.slideshow.hasAttribute('data-lb-responsive-slideshow')) apply(this.slideshow);
      return init.apply(this, arguments);
    };
    proto.lbResponsiveHook = true;
  }
  function refresh() {
    hook();
    document.querySelectorAll('[data-lb-responsive-slideshow]').forEach(function (el) {
      var T = window.theme, host = el.closest('[data-section-id]');
      var section = T && T.sections && typeof T.sections._findInstance === 'function' && host && T.sections._findInstance(host.dataset.sectionId);
      var slider = section && section.flickity, index = slider && slider.slideshow ? slider.slideshow.selectedIndex : 0;
      var wrapper = el.closest('.slideshow-wrapper');
    var pause = wrapper && wrapper.querySelector('.slideshow__pause');
      var paused = pause && pause.classList.contains('is-paused');
      apply(el);
      if (section && slider && typeof section.forceReload === 'function') {
        // The old theme binds a pause listener on construction, so replace the button before reinitializing.
        if (pause) pause.replaceWith(pause.cloneNode(true));
        section.initialIndex = index || 0;
        section.forceReload();
        if (paused && section.flickity) section.flickity.pause();
      }
    });
  }
  window.LBResponsiveBehavior = { refresh: refresh, apply: apply };
  hook();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true }); else refresh();
  if (mq.addEventListener) mq.addEventListener('change', refresh); else mq.addListener(refresh);
  document.addEventListener('shopify:section:load', function () { setTimeout(refresh, 0); });
})();
